module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/custom_marker.7df8315f.svg";